import { RootState } from "@/store/reducers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useUrlTitle = ({ url }: { url?: string }) => {
  const { googleApiKey } =
    useSelector((state: RootState) => state.appData.appData) ?? {};
  const [title, setTitle] = useState<string | undefined>();

  const extractVideoId = () => {
    const regex = /(?:youtu\.be\/|v=)([^&?/]+)/;
    const match = url?.match(regex);
    return match ? match[1] : null;
  };

  useEffect(() => {
    if (url) {
      const videoId = extractVideoId();
      if (!videoId) return;

      fetch(
        `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${googleApiKey}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.items?.[0]?.snippet?.title) {
            setTitle(data.items[0].snippet.title);
          } else {
            setTitle("");
          }
        })
        .catch((err) => {
          console.error(err);
          setTitle("");
        });
    }
  }, [url]);

  return {
    title,
  };
};
